import * as Yup from 'yup';
import 'yup-phone';

const requiredText = 'Это обязательное поле';
const requeredEmailOrPhone = 'Пожалуйста введите email или телефон'
const emailText = 'Введите корректный email адрес';

export const modalSellingSchema = Yup.object().shape({
    // TODO настроить как будет бэкенд
    number: Yup.number().min(4, 'Вы ввели слишком короткий номер'),
    series: Yup.number(),
    cash: Yup.number(),
    card: Yup.number(),
    isCash: Yup.boolean(),
    isCard: Yup.boolean(),
})

export const modalUserSchema = Yup.object({
    user: Yup.object({
        phone: Yup
            .string()
            .test(
                'oneOfRequired',
                requeredEmailOrPhone,
                (item, testContext) => {
                    return testContext.parent.email || testContext.parent.phone
                }
            )
        ,
        email: Yup
            .string()
            .email(emailText)
            .test(
                'oneOfRequired',
                requeredEmailOrPhone,
                (item,testContext) => {
                    return testContext.parent.email || testContext.parent.phone
                }
            ),
        first_name: Yup.string().required(requiredText),
        last_name: Yup.string().required(requiredText),
        username: Yup.string(),
        user_type: Yup.number(),
        sex: Yup.string(),
        birthday: Yup.string(),
        is_news_email: Yup.boolean(),
        comment: Yup.string(),
        wavesFile: Yup.string(),
        tubesFile: Yup.string(),
    }),
    address: Yup.object({
        country: Yup.string(),
        region: Yup.string(),
        district: Yup.string(),
        city: Yup.string(),
        street: Yup.string(),
        zip_code: Yup.number(),
        house: Yup.string(),
        building: Yup.string(),
        apartment: Yup.string(),
    }),
    documents: Yup.object({
        country: Yup.string(),
        document_type: Yup.number(),
        document_number: Yup.number(),
        document_granted_by: Yup.string(),
        document_serial: Yup.number(),
        document_granted: Yup.date(),
        document_department_code: Yup.number(),
    }),
})

export const createTaskSchemaSuperAdmin = Yup.object().shape({
    title: Yup.string().required(requiredText),
    source: Yup.number().required(requiredText),
    user: Yup
        .object()
        .nullable()
        .test(
            'oneOfRequired',
            'Необходимо указать группу или персонал',
            (item,testContext)=>{
                return (testContext.parent.user ||  (testContext.parent.groups && testContext.parent.groups.length > 0)  )
            }
        ),
    groups: Yup
        .array()
        .nullable()
        .test(
            'oneOfRequired',
            'Необходимо указать группу или персонал',
            (item,testContext)=> {
                return (testContext.parent.user || (testContext.parent.groups && testContext.parent.groups.length > 0) )
            }
        ),
})

export const createTaskSchemaStaff = Yup.object().shape({
    title: Yup.string().required(requiredText),
    source: Yup.number().required(requiredText),
    user: Yup
        .object()
        .nullable()
        .test(
            'oneOfRequired',
            'Необходимо указать группу или персонал',
            (item,testContext)=>{
                if(!testContext.parent.flagStaff){
                        return (!!testContext.parent.user !== null)
                    }
                    return true
            }
        ),
    groups: Yup
        .array()
        .nullable()
        .test(
            'oneOfRequired',
            'Необходимо указать группу или персонал',
            (item,testContext)=> {
                if(testContext.parent.flagStaff){
                    return ( testContext.parent.groups && testContext.parent.groups.length > 0  )
                }
                return true
            }
        ),
})

export const validateSchemaActivateCertificate = Yup.object().shape({
    number_series: Yup.string().required(requiredText),
})